import React, { useState, useEffect } from "react";
import "./dentalOffer.css";

const offerImages = [
  // Dental scaling procedure - ultrasonic scaler in action
  "https://images.unsplash.com/photo-1606811856475-5e6fcdc6e509?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8ZGVudGFsJTIwc2NhbGluZ3xlbnwwfHx8fDE3NDI0NDc1MjR8MA&auto=format&fit=crop&w=600&q=80",
  
  // Professional dental cleaning tools - scalers and polishers
  "https://images.unsplash.com/photo-1598256989800-fe5f95da9787?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8OHx8ZGVudGFsJTIwdG9vbHN8ZW58MHx8fHwxNzQyNDQ3NTI0fDA&auto=format&fit=crop&w=600&q=80",
  
  // Dental hygienist performing scaling
  "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8MTJ8ZGVudGFsJTIwaHlnaWVuaXN0fGVufDB8fHx8MTc0MjQ0NzUyNHww&auto=format&fit=crop&w=600&q=80",
  
  // Before and after teeth cleaning - showing plaque removal
  "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8Nnx8dGVldGglMjBjbGVhbmluZ3xlbnwwfHx8fDE3NDI1MDAxMTh8MA&auto=format&fit=crop&w=600&q=80",
  
  // Dental polishing procedure with rotating brush
  "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8MTB8ZGVudGFsJTIwcG9saXNoaW5nfGVufDB8fHx8MTc0MjQ4MTc5OXww&auto=format&fit=crop&w=600&q=80",
  
  // Clean teeth after scaling and polishing
  "https://images.unsplash.com/photo-1489278353717-f64c6ee8a4d2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8MTR8Y2xlYW4lMjB0ZWV0aHxlbnwwfHx8fDE3MTg3NjA1Mjl8MA&auto=format&fit=crop&w=600&q=80",
  
  // Dental scaling instruments close-up
  "https://images.unsplash.com/photo-1495112612632-9c7423865423?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8MTZ8ZGVudGFsJTIwaW5zdHJ1bWVudHN8ZW58MHx8fHwxNzE4Njk0MDUyfDA&auto=format&fit=crop&w=600&q=80",
  
  // Professional dental chair setup for scaling procedure
  "https://images.unsplash.com/photo-1609840113564-ab4aba4956c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8MTh8ZGVudGFsJTIwY2hhaXJ8ZW58MHx8fHwxNzE4NDU3Mjk5fDA&auto=format&fit=crop&w=600&q=80",
  
  // Healthy gums after scaling treatment
  "https://images.unsplash.com/photo-1473232117216-c950d4ef2e14?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MXxzZWFyY2h8MjB8aGVhbHRoeSUyMGd1bXN8ZW58MHx8fHwxNzE4NjQ0Njc5fDA&auto=format&fit=crop&w=600&q=80"
];

const DentalOffer = () => {
  const [showOffer, setShowOffer] = useState(false);
  const [activeImg, setActiveImg] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOffer(true);
      document.body.style.overflow = "hidden";
    }, 3000);

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "auto";
    };
  }, []);

  // Carousel effect for images
  useEffect(() => {
    if (!showOffer) return;
    const imgTimer = setInterval(() => {
      setActiveImg((prev) => (prev + 1) % offerImages.length);
    }, 1800);
    return () => clearInterval(imgTimer);
  }, [showOffer]);

  const handleClose = () => {
    setShowOffer(false);
    document.body.style.overflow = "auto";
  };

  const handleBookNow = () => {
    // Direct to consultation booking page
    window.open("/bookconsultation", "_blank");
    setShowOffer(false);
    document.body.style.overflow = "auto";
  };

  if (!showOffer) return null;

  return (
    <div className="offer-overlay" id="dental-offer-overlay">
      <div className="offer-popup offer-animated">
        <button className="offer-close" onClick={handleClose}>
          ×
        </button>
        <div className="offer-img-carousel">
          {offerImages.map((img, idx) => (
            <img
              key={img}
              src={img}
              alt="Dental Scaling & Polishing"
              className={`offer-carousel-img${activeImg === idx ? " active" : ""}`}
              style={{ display: activeImg === idx ? "block" : "none" }}
            />
          ))}
          <div className="offer-blink-badge">🔥 Limited Time Offer 🔥</div>
        </div>
        <div className="offer-content offer-content-animated">
          <h2 className="offer-title">Special Dental Package</h2>
          <div className="offer-treatment">Scaling &amp; Polishing</div>
          <div className="offer-price">
            <span className="offer-price-currency">₹</span>
            <span className="offer-price-amount">399</span>
            <span className="offer-price-only">only</span>
          </div>
          <div className="offer-benefits">
            <div className="offer-benefit">
              <span className="offer-benefit-icon">✓</span>
              <span>Professional Teeth Cleaning</span>
            </div>
            <div className="offer-benefit">
              <span className="offer-benefit-icon">✓</span>
              <span>Removes Plaque &amp; Stains</span>
            </div>
            <div className="offer-benefit">
              <span className="offer-benefit-icon">✓</span>
              <span>Healthier Gums</span>
            </div>
          </div>
          <button className="offer-button offer-blink-btn" onClick={handleBookNow}>
            Book Your Consultation
          </button>
        </div>
      </div>
    </div>
  );
};

export default DentalOffer;
